import { useRecoilCallback, useRecoilState } from 'recoil';
import {
  marks,
  measureReportExitActionEnd,
  measureReportExitActionStart,
  ReportExitAction,
  reportExitActionDataState,
  ReportExitActionMetadata,
} from './performance';
import { performance } from 'utils/performance';
import { useCallback } from 'react';

export const useReportExitActionData = () => {
  const [reportExitActionData, setReportExitActionData] = useRecoilState(reportExitActionDataState);

  const clear = useCallback(() => {
    performance.clearMarksByName([
      marks.sirona.ReportExitAction.Start,
      marks.sirona.ReportExitAction.End,
    ]);

    setReportExitActionData(null);
  }, [setReportExitActionData]);

  const measureReportExitActionWithDialog = useCallback(async () => {
    measureReportExitActionStart();

    if (reportExitActionData == null) return;

    setReportExitActionData((prev) =>
      prev == null
        ? prev
        : {
            ...prev,
            hasConfirmationDialogTriggered: true,
          }
    );
  }, [reportExitActionData, setReportExitActionData]);

  const measureReportExitActionStartWithMetadata = useCallback(
    (metadata: ReportExitActionMetadata) => {
      measureReportExitActionStart();

      setReportExitActionData(metadata);
    },
    [setReportExitActionData]
  );

  const measureReportExitActionEndWithMetadata = useRecoilCallback(
    ({ snapshot }) =>
      async ({ exitAction }: { exitAction?: ReportExitAction }) => {
        const current = await snapshot.getPromise(reportExitActionDataState);

        if (current == null) return;

        if (exitAction != null) {
          measureReportExitActionEnd({
            ...current,
            exitAction,
          });
        } else {
          measureReportExitActionEnd(current);
        }

        clear();
      },
    [clear]
  );

  return {
    reportExitActionData,
    setReportExitActionData,
    measureReportExitActionWithDialog,
    measureReportExitActionStartWithMetadata,
    measureReportExitActionEndWithMetadata,
  };
};
